__turbopack_context__.v({
  "drawerHeaderActions": "Y5MWMG_drawerHeaderActions",
  "drawerLegalLinks": "Y5MWMG_drawerLegalLinks",
  "drawerNav": "Y5MWMG_drawerNav",
  "drawerNavList": "Y5MWMG_drawerNavList",
  "drawerPanel": "Y5MWMG_drawerPanel",
  "header": "Y5MWMG_header",
  "subnavCopy": "Y5MWMG_subnavCopy",
  "subnavSlot": "Y5MWMG_subnavSlot",
  "theme-toggle-pop": "Y5MWMG_theme-toggle-pop",
  "themeIcon": "Y5MWMG_themeIcon",
  "themeIconAnimating": "Y5MWMG_themeIconAnimating",
});
